module.exports = __webpack_public_path__ + "assets/img/NDschool.a6cf71ef.png";